import React from 'react';
import { formatAMPMWidthSecond, formatSeconds, goalDataTypeEnums, Images, sessionStatusEnums } from 'utils';
import { EditWithIcon, TextRow, TimeInputFull } from 'components';
import moment from 'moment';
import { renderAverageRow } from '../../../../client/clientSingle/clientClinical/goals/trialData/constants';

const updateDateTime = (originalDateTime, newTime) => {
    if (!originalDateTime || !newTime) return null;

    const datePart = originalDateTime.slice(0, 11);

    const timezoneMatch = originalDateTime.match(/([+-]\d{2}:\d{2})$/);
    const offset = timezoneMatch ? timezoneMatch[1] : '';

    return `${datePart}${newTime}${offset}`;
};

export const durationHistoryHead = (sessionById) => [
    { name: 'trial', title: 'Trial', custom: false, noSearch: true },
    { name: 'startTime', title: 'Start Time', custom: false, noSearch: true },
    { name: 'endTime', title: 'End Time', custom: false, noSearch: true },
    { name: 'duration', title: 'Duration', custom: false, noSearch: true },
    sessionById?.status === sessionStatusEnums.IN_PROGRESS && { name: 'action', title: ' ', custom: false, noSearch: true, width: '50px' },
];

export const durationHistoryBody = (sessionById, selectedRow, handleChange, error, load) => [
    { rowText: (item, index) => <p>{index + 1}</p> },
    {
        rowText: (item) => {
            return (
                <div>
                    {selectedRow?.id === item?.id ? (
                        <div>
                            <TimeInputFull
                                customClass={'history-log-time-input'}
                                name={'startTime'}
                                onChange={(e) => {
                                    const updated = updateDateTime(item?.startTime, e.target.value);
                                    handleChange({ target: { name: 'startTime', value: updated } });
                                }}
                                typeError={error === 'startTime'}
                                errorFalse={true}
                                defaultValue={selectedRow?.startTime ? selectedRow?.startTime?.slice(11, 19) : null}
                            />
                        </div>
                    ) : (
                        formatAMPMWidthSecond(item?.startTime)
                    )}
                </div>
            );
        },
    },
    {
        rowText: (item) => {
            return (
                <div>
                    {selectedRow?.id === item?.id ? (
                        <div>
                            <TimeInputFull
                                customClass={'history-log-time-input'}
                                name={'endTime'}
                                onChange={(e) => {
                                    const updated = updateDateTime(item?.endTime, e.target.value);
                                    handleChange({ target: { name: 'endTime', value: updated } });
                                }}
                                typeError={error === 'endTime' || error === 'endBeforeStart'}
                                errorFalse={true}
                                defaultValue={selectedRow?.endTime ? selectedRow?.endTime?.slice(11, 19) : null}
                            />
                        </div>
                    ) : (
                        formatAMPMWidthSecond(item?.endTime, true)
                    )}
                </div>
            );
        },
    },
    { rowText: (item) => <div>{formatSeconds(item?.value)}</div> },
    sessionById?.status === sessionStatusEnums.IN_PROGRESS && {
        button: (fn, item) => (
            <>
                {selectedRow?.id === item?.id ? (
                    <div className="flex-align-center" style={{ gap: 8 }}>
                        <EditWithIcon
                            disabled={load}
                            load={load && selectedRow?.id === item?.id}
                            icon={Images.checkmarkBlue}
                            handleClick={() => fn('save')}
                        />
                        <EditWithIcon icon={Images.closeGray} handleClick={() => fn('remove')} />
                    </div>
                ) : (
                    <div className="flex-align-center" style={{ gap: 8 }}>
                        <EditWithIcon icon={Images.edit} handleClick={() => fn('edit')} />
                        <EditWithIcon icon={Images.redTrash} handleClick={() => fn('delete')} />
                    </div>
                )}
            </>
        ),
    },
];

export const historyLogNotYet = {
    height: '250px',
    title: 'You don’t have History Logs yet',
    subTitle: 'Nothing new for now. Enjoy the silence while it lasts',
    image: Images.emptyFolder,
};

export const DELETE_TRIAL_LOG_ACTION_TYPE = 'DELETE_TRIAL_LOG';

export const rateHistoryHead = (sessionById) => [
    { name: 'trial', title: 'Trial', custom: false, noSearch: true },
    { name: 'startTime', title: 'Start Time', custom: false, noSearch: true },
    { name: 'endTime', title: 'End Time', custom: false, noSearch: true },
    { name: 'duration', title: 'Duration', custom: false, noSearch: true },
    { name: 'frequency', title: 'Frequency', custom: false, noSearch: true },
    { name: 'rate', title: 'Rate', custom: false, noSearch: true },
    sessionById?.status === sessionStatusEnums.IN_PROGRESS && { name: 'action', title: ' ', custom: false, noSearch: true, width: '50px' },
];

export const rateHistoryBody = (sessionById, selectedRow, handleChange, error, load) => [
    { rowText: (item, index) => <p>{index + 1}</p> },
    {
        rowText: (item) => {
            return (
                <div>
                    {selectedRow?.id === item?.id ? (
                        <div>
                            <TimeInputFull
                                customClass={'history-log-time-input'}
                                name={'startTime'}
                                onChange={(e) => {
                                    const updated = updateDateTime(item?.startTime, e.target.value);
                                    handleChange({ target: { name: 'startTime', value: updated } });
                                }}
                                typeError={error === 'startTime'}
                                errorFalse={true}
                                defaultValue={selectedRow?.startTime ? selectedRow?.startTime?.slice(11, 19) : null}
                            />
                        </div>
                    ) : (
                        formatAMPMWidthSecond(item?.startTime)
                    )}
                </div>
            );
        },
    },
    {
        rowText: (item) => {
            return (
                <div>
                    {selectedRow?.id === item?.id ? (
                        <div>
                            <TimeInputFull
                                customClass={'history-log-time-input'}
                                name={'endTime'}
                                onChange={(e) => {
                                    const updated = updateDateTime(item?.endTime, e.target.value);
                                    handleChange({ target: { name: 'endTime', value: updated } });
                                }}
                                typeError={error === 'endTime' || error === 'endBeforeStart'}
                                errorFalse={true}
                                defaultValue={selectedRow?.endTime ? selectedRow?.endTime?.slice(11, 19) : null}
                            />
                        </div>
                    ) : (
                        formatAMPMWidthSecond(item?.endTime, true)
                    )}
                </div>
            );
        },
    },
    {
        rowText: (item) => {
            const startMoment = moment(item?.startTime);
            const endMoment = moment(item?.endTime);
            // Clamp negative diffs (cross-tab clock skew can produce them) so
            // the row renders 0s instead of malformed negative-seconds output.
            const differenceInSeconds = Math.max(0, endMoment.diff(startMoment, 'seconds'));

            return <div>{formatSeconds(differenceInSeconds)}</div>;
        },
    },

    {
        rowText: (item) => (
            <div>
                {selectedRow?.id === item?.id ? (
                    <input
                        style={{
                            height: 36,
                            width: 100,
                            border: error === 'value' ? '1px solid #f44336' : '1px solid #0C66E4',
                        }}
                        className="score-count-input-box"
                        onChange={(e) =>
                            e?.target?.value >= 0 &&
                            handleChange({
                                target: {
                                    name: 'value',
                                    // Same 0–999 range as the live rate counter in the session.
                                    value: Number(e?.target?.value) > 999 ? '999' : e?.target?.value,
                                },
                            })
                        }
                        value={selectedRow?.value}
                        type="number"
                        min={0}
                        max={999}
                    />
                ) : (
                    <TextRow name={item?.value ? item?.value : '0'} />
                )}
            </div>
        ),
    },

    { rowText: (item) => <TextRow name={`${item?.trialInfo?.value}${item?.trialInfo?.info}`} /> },

    sessionById?.status === sessionStatusEnums.IN_PROGRESS && {
        button: (fn, item) => (
            <>
                {selectedRow?.id === item?.id ? (
                    <div className="flex-align-center" style={{ gap: 8 }}>
                        <EditWithIcon
                            disabled={load}
                            load={load && selectedRow?.id === item?.id}
                            icon={Images.checkmarkBlue}
                            handleClick={() => fn('save')}
                        />
                        <EditWithIcon icon={Images.closeGray} handleClick={() => fn('remove')} />
                    </div>
                ) : (
                    <div className="flex-align-center" style={{ gap: 8 }}>
                        <EditWithIcon icon={Images.edit} handleClick={() => fn('edit')} />
                        <EditWithIcon icon={Images.redTrash} handleClick={() => fn('delete')} />
                    </div>
                )}
            </>
        ),
    },
];

export const trialHistoryHead = (sessionById, type) => {
    switch (type) {
        case goalDataTypeEnums.WHOLE_INTERVAL:
        case goalDataTypeEnums.PARTIAL_INTERVAL:
        case goalDataTypeEnums.MOMENTARY_TIME_SAMPLING:
            return [
                { name: 'trial', title: 'Trial', custom: false, noSearch: true },
                { name: 'startTime', title: 'Start Time', custom: false, noSearch: true },
                { name: 'endTime', title: 'End Time', custom: false, noSearch: true },
                { name: 'prompt', title: 'Prompt', custom: false, noSearch: true },
                { name: 'time', title: 'Time Collected', custom: false, noSearch: true },
                sessionById?.status === sessionStatusEnums.IN_PROGRESS && {
                    name: 'action',
                    title: ' ',
                    custom: false,
                    noSearch: true,
                    width: '50px',
                },
            ];

        case goalDataTypeEnums.LATENCY:
            return [
                { name: 'trial', title: 'Trial', custom: false, noSearch: true },
                { name: 'latency', title: 'Latency', custom: false, noSearch: true },
                { name: 'prompt', title: 'Prompt', custom: false, noSearch: true },
                { name: 'time', title: 'Time Collected', custom: false, noSearch: true },
                sessionById?.status === sessionStatusEnums.IN_PROGRESS && {
                    name: 'action',
                    title: ' ',
                    custom: false,
                    noSearch: true,
                    width: '50px',
                },
            ];

        case goalDataTypeEnums.FREQUENCY:
            return [
                { name: 'trial', title: 'Trial', custom: false, noSearch: true },
                { name: 'frequency', title: 'Frequency', custom: false, noSearch: true },
                { name: 'time', title: 'Time Collected', custom: false, noSearch: true },
                // sessionById?.status === sessionStatusEnums.IN_PROGRESS &&
                // { name: 'action', title: ' ', custom: false, noSearch: true, width: '50px' },
            ];

        case goalDataTypeEnums.RATING:
            return [
                { name: 'trial', title: 'Trial', custom: false, noSearch: true },
                { name: 'rate', title: 'Rate', custom: false, noSearch: true },
                { name: 'time', title: 'Time Collected', custom: false, noSearch: true },
                sessionById?.status === sessionStatusEnums.IN_PROGRESS && {
                    name: 'action',
                    title: ' ',
                    custom: false,
                    noSearch: true,
                    width: '50px',
                },
            ];

        default:
            return [
                { name: 'trial', title: 'Trial', custom: false, noSearch: true },
                { name: 'prompt', title: 'Prompt', custom: false, noSearch: true },
                { name: 'time', title: 'Time Collected', custom: false, noSearch: true },
                sessionById?.status === sessionStatusEnums.IN_PROGRESS && {
                    name: 'action',
                    title: ' ',
                    custom: false,
                    noSearch: true,
                    width: '50px',
                },
            ];
    }
};

export const trialHistoryBody = (sessionById, type) => {
    switch (type) {
        case goalDataTypeEnums.LATENCY:
            return [
                { rowText: (item, index) => <p>{index + 1}</p> },
                { rowText: (item) => formatSeconds(item?.value) },
                { rowText: (item) => <div>{renderAverageRow({ ...item, dataType: type })}</div> },
                { rowText: (item) => <div>{item?.timeCollected ? `${moment(item?.timeCollected).local().format('h:mm A')}` : '--'}</div> },
                sessionById?.status === sessionStatusEnums.IN_PROGRESS && {
                    button: (fn) => (
                        <>
                            <div className="flex-align-center" style={{ gap: 8 }}>
                                <EditWithIcon icon={Images.redTrash} handleClick={() => fn('delete')} />
                            </div>
                        </>
                    ),
                },
            ];

        case goalDataTypeEnums.WHOLE_INTERVAL:
        case goalDataTypeEnums.PARTIAL_INTERVAL:
        case goalDataTypeEnums.MOMENTARY_TIME_SAMPLING:
            return [
                { rowText: (item, index) => <p>{index + 1}</p> },
                { rowText: (item) => <div>{item?.startTime ? moment(item?.startTime).local().format('h:mm A') : '--'}</div> },
                { rowText: (item) => <div>{item?.endTime ? moment(item?.endTime).local().format('h:mm A') : '--'}</div> },
                { rowText: (item) => <div>{renderAverageRow({ ...item, dataType: type })}</div> },
                { rowText: (item) => <div>{item?.timeCollected ? `${moment(item?.timeCollected).local().format('h:mm A')}` : '--'}</div> },
                sessionById?.status === sessionStatusEnums.IN_PROGRESS && {
                    button: (fn) => (
                        <>
                            <div className="flex-align-center" style={{ gap: 8 }}>
                                <EditWithIcon icon={Images.redTrash} handleClick={() => fn('delete')} />
                            </div>
                        </>
                    ),
                },
            ];

        case goalDataTypeEnums.FREQUENCY:
            return [
                { rowText: (item, index) => <p>{index + 1}</p> },
                { rowText: (item) => <div className="rating-row-box">{item?.value}</div> },
                { rowText: (item) => <div>{item?.timeCollected ? `${moment(item?.timeCollected).local().format('h:mm A')}` : '--'}</div> },
            ];

        default:
            return [
                { rowText: (item, index) => <p>{index + 1}</p> },
                { rowText: (item) => <div>{renderAverageRow({ ...item, dataType: type })}</div> },
                { rowText: (item) => <div>{item?.timeCollected ? `${moment(item?.timeCollected).local().format('h:mm A')}` : '--'}</div> },
                sessionById?.status === sessionStatusEnums.IN_PROGRESS && {
                    button: (fn) => (
                        <>
                            <div className="flex-align-center" style={{ gap: 8 }}>
                                <EditWithIcon icon={Images.redTrash} handleClick={() => fn('delete')} />
                            </div>
                        </>
                    ),
                },
            ];
    }
};
